module.exports = __webpack_public_path__ + "img/gn002.81c65a95.jpg";